var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "d-flex flex-column gr-6",
      attrs: { "data-qa": "meeting_card" },
    },
    [
      _vm.isStaff && !_setup.isMobile
        ? _c(
            "a",
            {
              staticClass:
                "adminka mx-0 pa-1 d-inline-block text-body-2 align-self-start",
              attrs: {
                target: "_blank",
                rel: "noopener noreferrer",
                href: _setup.reverseFull({
                  name: "admin:info_ethicalcommissionmeetingcase_change",
                  args: [_vm.meetingCase.id],
                }),
              },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_setup.t("Править отзыв", _setup.options)) +
                  "\n  "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "text-subtitle-1 text--text",
          attrs: { "data-qa": "meeting_card_case_title" },
        },
        [
          _vm._v("\n    " + _vm._s(_setup.t("Отзыв №", _setup.options)) + " "),
          _c("span", { attrs: { "data-qa": "meeting_card_case_number" } }, [
            _vm._v(_vm._s(_vm.meetingCase.case_number)),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(_setup.CardSection, {
        staticClass: "mt-n2",
        attrs: {
          title: _setup.t("Описание ситуации", _setup.options),
          description: _vm.meetingCase.situation_description,
        },
      }),
      _vm._v(" "),
      _c(
        _setup.CardSection,
        { attrs: { title: _setup.t("Итоги", _setup.options) } },
        [
          typeof _vm.meetingCase.is_ethical_count === "number"
            ? _c(
                "div",
                {
                  staticClass:
                    "d-flex align-center justify-space-between meeting-card-result",
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_setup.t("Отзыв этичен", _setup.options)) +
                      "\n      "
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "meeting-card-result__count text-subtitle-2 success--text bg-success",
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.meetingCase.is_ethical_count) +
                          "\n      "
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          typeof _vm.meetingCase.is_not_ethical_count === "number"
            ? _c(
                "div",
                {
                  staticClass:
                    "d-flex align-center justify-space-between meeting-card-result",
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_setup.t("Отзыв неэтичен", _setup.options)) +
                      "\n      "
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "meeting-card-result__count text-subtitle-2 error--text bg-error",
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.meetingCase.is_not_ethical_count) +
                          "\n      "
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.meetingCase.voting_results
            ? [
                _vm._v(
                  "\n      " + _vm._s(_vm.meetingCase.voting_results) + "\n    "
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(_setup.CardSection, {
        attrs: {
          title: _setup.t("Вывод", _setup.options),
          description: _vm.meetingCase.conclusion,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }